export default __webpack_public_path__ + "static/media/cyl_example_o_prasteni.098e725f.png";